import { BotElement } from '../types/model-types';


class Response extends BotElement {
    choice: string;

    constructor(choice: string) {
      super("response")
      this.choice = choice;
    }

    /* istanbul ignore next */
    shouldStop(context: object) {
        return false;
    }
}


export {
    Response
}
